import { useEffect, useState } from "react";
import { Cookie, Copy, ArrowsClockwise } from "@phosphor-icons/react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { ScrollArea } from "../components/ui/scroll-area";
import { toast } from "sonner";
import { listarCookies } from "../lib/api";

export default function AbaCookies({ botId, botStatus }) {
    const [cookies, setCookies] = useState([]);
    const [carregando, setCarregando] = useState(false);
    const [filtro, setFiltro] = useState("");

    const carregar = async () => {
        if (botStatus !== "rodando") {
            setCookies([]);
            return;
        }
        setCarregando(true);
        try {
            const lista = await listarCookies(botId);
            setCookies(lista);
        } catch (e) {
            toast.error(e?.response?.data?.erro || "Falha ao listar cookies");
        } finally {
            setCarregando(false);
        }
    };

    useEffect(() => {
        carregar();
        const i = setInterval(carregar, 5000);
        return () => clearInterval(i);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [botId, botStatus]);

    const copiarTudo = () => {
        const linhas = cookies.map((c) => `${c.nome}=${c.valor}`).join("; ");
        navigator.clipboard.writeText(linhas);
        toast.success("Cookies copiados");
    };

    const filtrados = cookies.filter((c) =>
        !filtro || c.nome.toLowerCase().includes(filtro.toLowerCase()) || c.dominio.toLowerCase().includes(filtro.toLowerCase())
    );

    if (botStatus !== "rodando") {
        return (
            <div className="border border-zinc-800 rounded-md p-8 text-center text-zinc-500 text-sm">
                <Cookie size={32} className="mx-auto mb-3 opacity-50" />
                Inicie o bot para visualizar os cookies da sessão.
            </div>
        );
    }

    return (
        <div className="space-y-3">
            <div className="flex items-center gap-2">
                <Input
                    data-testid="input-filtro-cookies"
                    placeholder="Filtrar por nome ou domínio..."
                    value={filtro}
                    onChange={(e) => setFiltro(e.target.value)}
                    className="bg-zinc-900 border-zinc-800 focus:border-zinc-600 font-mono text-xs flex-1"
                />
                <Button size="sm" variant="outline" data-testid="btn-recarregar-cookies"
                    className="bg-transparent border-zinc-800 hover:bg-zinc-800" onClick={carregar} disabled={carregando}>
                    <ArrowsClockwise size={14} className={carregando ? "animate-spin" : ""} />
                </Button>
                <Button size="sm" data-testid="btn-copiar-cookies"
                    className="bg-white text-zinc-950 hover:bg-zinc-200" onClick={copiarTudo}>
                    <Copy size={14} className="mr-1" /> Copiar
                </Button>
            </div>

            <div className="bg-zinc-900 border border-zinc-800 rounded-md">
                <div className="grid grid-cols-[1fr_1.5fr_1fr_60px] text-[10px] uppercase tracking-wider text-zinc-500 font-mono px-3 py-2 border-b border-zinc-800">
                    <div>Nome</div>
                    <div>Valor</div>
                    <div>Domínio</div>
                    <div>Flags</div>
                </div>
                <ScrollArea className="h-[450px]">
                    {filtrados.length === 0 ? (
                        <div className="text-center text-zinc-600 py-12 text-sm">Nenhum cookie encontrado.</div>
                    ) : (
                        <div data-testid="lista-cookies">
                            {filtrados.map((c, i) => (
                                <div key={`${c.nome}-${i}`} className="grid grid-cols-[1fr_1.5fr_1fr_60px] items-center text-xs font-mono px-3 py-1.5 border-b border-zinc-800/50">
                                    <span className="text-zinc-200 truncate font-medium">{c.nome}</span>
                                    <span className="text-zinc-400 truncate break-all">{c.valor}</span>
                                    <span className="text-zinc-500 truncate">{c.dominio}</span>
                                    <span className="text-[10px] text-zinc-600 space-x-1">
                                        {c.http_only && <span title="HttpOnly">H</span>}
                                        {c.secure && <span title="Secure">S</span>}
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}
                </ScrollArea>
            </div>
        </div>
    );
}
